export const hasSpecialCharacters = (value) => {
  const regex = /^[a-zA-Z ]+$/;
  return !regex.test(value);
};
